import React from "react";
import '../../../model/index.css';

const P5 = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">Forest4 Darts Cafe</h1>
      <div className="section">
        <h2>新加坡 DOWNTOWN EAST #01-313</h2>
        <p className="store-info"></p>
        <img src="./partner/5/1.pic.jpg"  alt=""/>
        <img src="./partner/5/2.pic.jpg"  alt=""/>
        <img src="./partner/5/3.pic.jpg"  alt=""/>
        <img src="./partner/5/4.pic.jpg"  alt=""/>
        <img src="./partner/5/5.pic.jpg"  alt=""/>
        <img src="./partner/5/6.pic.jpg"  alt=""/>
      </div>
    </div>
  );
};

export default P5;
